<template>
	<v-app>

		<!-- DEFAULT -->
		<template v-if="user">
			<Default v-if="layout == 'default' && !shop"/>
			<Waiter v-if="layout == 'waiter'" && !shop/>
		</template>

		<!-- OUTSIDER -->
		<Outsider v-if="layout == 'outsider'  && !shop" />

		<!-- PRODUCTER -->
		<Producter v-if="shop"/>

		<!-- SNACKBAR -->
		<v-snackbar top center v-model="showSnack" :timeout="3000" :color="snack.kind" v-if="snack != null">
			<v-layout>
				<v-icon color="white" small v-if="snack.kind=='success'">fa-check</v-icon>
        		<v-icon color="white" small v-if="snack.kind=='error'">fa-exclamation-triangle</v-icon>
        		<v-icon color="white" small v-if="snack.kind=='warning'">fa-exclamation-triangle</v-icon>
				<span class="ml-3">{{ snack.text }}</span>
			</v-layout>
   		 </v-snackbar>

		<GettingLoader v-if="layout == 'default' && user==null" />
  	</v-app>
</template>

<script>
import Default from '@/components/layouts/Default'
import Waiter from '@/components/layouts/Waiter'
import Outsider from '@/components/layouts/Outsider'
import Producter from '@/components/layouts/Producter'
import NavRoutes from '@/config/navRoutes'

export default {
	name: 'App',
  	data: () => ({
    	layout: 'default',
		showSnack: false,
		shop: false
  	}),
	components: {
		Default,
		Waiter,
		Outsider,
		Producter
	},
	computed: {
		snack() {
      		return this.$store.getters.snack;
		}
	},
	watch: {
		'$route': {
			handler: function(to, from) {
				if (to.meta.layout) {
					this.layout = to.meta.layout;
				}

				this.checkUserLayout();
				this.$vuetify.goTo(0, {duration: 0});
			},
			deep: true,
			immediate: true
      	},
		snack(value) {
			if (value) {
				this.showSnack = true;
			} else {
				this.showSnack = false;
			}
		},
		user(val) {
			if (val != null) {
				this.checkUserLayout();
				this.checkPermission();
			}
		}
	}, 
	mounted() {
		this.checkUserLayout();
	},
	methods: {
		checkUserLayout() {		
			if (this.user) {
				if (this.user.role.master || this.user.role.captain || this.user.role.director) {
					this.layout = 'default';
					return;
				}
				
				// If Student
				if (this.user.group) {
					this.layout = 'default';
				} else {
					this.layout = 'waiter';
				}
			}

			if (this.$route.path=='/cart' || 
				this.$route.path=='/subscription' || this.$route.path.substr(0,26)=='/cart/success-subscription' || this.$route.path.substr(0,9)=='/checkout' ||
				this.$route.path=='/cart/program-application' || this.$route.path=='/cart/success-program-application' || 
				this.$route.path=='/cart/summercamp-application' || this.$route.path=='/cart/success-summercamp-application') {
					this.shop = true;
			} else {
					this.shop = false;
			}
		},
		checkPermission() {
			if (this.$route.meta) {
				let ans = this.permission(this.$route.meta);

				if (ans === false) {
					this.$router.push('/home');
				}
			}
		}
	}
}
</script>

<style>
	a {
		color: #616161 !important;
	}
	.v-btn {
		/* text-transform: none !important; */
		font-size: 12px !important;
	}
	/* .v-btn__content {
    	font-size: 11px !important;
  	} */
	.v-application {
		background-color: #fdfdfd !important;
	}
</style>


